/* src/components/auth/UsernameOnboardingScreen.js */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../../contexts/ProfileContext";
import { useLoading } from "../../contexts/LoadingContext";
import AppHeader from "../ui/AppHeader";
import LoadingSpinner from "../ui/LoadingSpinner";

export default function UsernameOnboardingScreen() {
  const { addProfile, isLoading: isProfileLoading, authUser } = useProfile();
  const { showLoading, hideLoading, updateMessage } = useLoading();
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const validate = u => {
    if (!u.trim()) return "Username is required";
    if (u.length < 3 || u.length > 25) return "3–25 characters required";
    if (!/^[a-zA-Z0-9_-]+$/.test(u)) return "Only letters, numbers, _ and –";
    return "";
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const v = validate(username);
    if (v) return setError(v);

    setSaving(true);
    showLoading("Creating profile...");

    const profile = await addProfile({ username });
    if (profile) {
      updateMessage("Profile created! Redirecting...");
      navigate("/dashboard", { replace: true });
    } else {
      hideLoading();
      setSaving(false);
    }
  };

  // Render header + spinner while profile data is loading
  if (isProfileLoading) {
    return (
      <>
        <AppHeader authUser={authUser} toggleMobileMenu={() => {}} />
        <LoadingSpinner message="Loading user data…" fullScreen={true} />
      </>
    );
  }

  return (
    <>
      <AppHeader authUser={authUser} toggleMobileMenu={() => {}} />
      <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
        <form
          onSubmit={handleSubmit}
          className="bg-white p-8 rounded-lg shadow-md w-full max-w-md"
        >
          <h1 className="text-2xl font-bold mb-6 text-gray-800">
            Pick a username
          </h1>

          <input
            className="w-full px-3 py-2 border rounded focus:ring-indigo-500"
            value={username}
            onChange={e => {
              setUsername(e.target.value);
              setError("");
            }}
            placeholder="e.g. BrainTrainer"
            disabled={saving}
          />
          {error && <p className="text-red-600 text-sm mt-2">{error}</p>}

          <button
            type="submit"
            disabled={saving}
            className="mt-6 w-full bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700 disabled:opacity-50"
          >
            {saving ? "Creating…" : "Continue"}
          </button>
        </form>
      </div>
    </>
  );
}
